
export class LayerExportQuery {

  public serviceUrl: string;

  public expression: string

  public outFields: string;
}
